module.exports = __webpack_public_path__ + "img/send.f4c1b6a2.png";